/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const RECALL_UNUSED_INVITES = gql`
  mutation RecallUnusedInvite($input: recallInviteInput) {
    recallUnusedInvite(input: $input) {
      id
      inviteType
      maxInvites
      partition
      referalsUsed
      purchased
      sectionOptType
      presentation {
        id
        name
      }
      sections {
        id
        images
      }
      user {
        email
      }
    }
  }
`;
